import React from 'react'
import { Table, Row, Col, Tooltip } from 'antd'
import {
  PlusCircleOutlined,
  LockOutlined
} from '@ant-design/icons'
import styled from 'styled-components'

import isNull from '../../../../utils/isNull'
import { getGPPValue, getShowdownGPPValue } from '../../../../utils/gpp-value'

const StyledTable = styled(Table)`
  td {
    text-align: center;
    padding: 2px !important;
  }

  tr th {
    text-align: center !important;
  }

  tr.ant-table-row-level-0:hover > td {
    background: #e6f7ff !important;
  }

  *, *:before, *:after {
    -moz-box-sizing: border-box; -webkit-box-sizing: border-box; box-sizing: border-box;
  }

  .divide {
    border-right: 2px solid #4004A3 !important;
  }
`

const Lock = () => (
  <Tooltip title="Upgrade for this feature">
    <LockOutlined />
  </Tooltip>
)

const PlusIcon = styled(PlusCircleOutlined)`
  cursor: pointer;
  padding-top: 8px;
`

const addCol = (onAdd, selectedPlayers) => [
  {
    title: 'Add',
    width: '50px',
    render: (_, row) => {
      return (
        <PlusIcon onClick={() => onAdd(row.Id)}/>
      )
    }
  }
]

const playerDetailsCols =  (setWidths, showdown) => {
  const cols = [
    {
      title: 'Player Name',
      dataIndex: 'Name',
      key: 'playerName',
      width: setWidths ? 120 : undefined,
    },
    {
      title: 'Salary',
      dataIndex: 'Salary',
      key: 'salary',
      defaultSortOrder: 'descend',
      sorter: (a, b) => Number(a.Salary - b.Salary),
    },
    {
      title: 'Pos',
      dataIndex: 'Position',
      key: 'position',
      className: showdown ? '' : 'divide',
      width: setWidths ? 60 : undefined,
    },
  ]

  if (showdown) {
    cols.push({
      title: 'Roster Pos',
      dataIndex: 'RosterPosition',
      key: 'rosterPosition',
      className: 'divide',
      width: setWidths ? 80 : undefined,
    })
  }

  return cols
}

const teamAndGameInfoCols = (setWidths) => [
    {
      title: 'Team',
      dataIndex: 'TeamAbbrev',
      key: 'teamAbbrev',
      width: setWidths ? 80 : undefined,
      render: (text) => {
        try {
          return (
            <img src={require(`../../../../assets/images/mlb/teamlogos/${text}.png`).default} style={{width: '28px'}} alt={text}/>
          )
        } catch (e) {
          
        }
      },
    },
    {
      title: 'Opp',
      dataIndex: 'Opp',
      key: 'opp',
      width: setWidths ? 80 : undefined,
      render: (text) => {
        try {
          return (
            <img src={require(`../../../../assets/images/mlb/teamlogos/${text}.png`).default} style={{width: '28px'}} alt={text}/>
          )
        } catch (e) {
          
        }
      },
    }
]

const playerProjectionCols = (permissions, site, showdown) => [
    {
      title: (
        <Tooltip placement="top" title={"DFSForecast’s projected point total"}>
          <span>Proj Pts</span>
        </Tooltip>
      ),
      key: 'dKPts',
      sorter: (a, b) => Number(b.HouseProjPts || b.ProjPts) - Number(a.HouseProjPts || a.ProjPts),
      render: (_, row) => {
        if (permissions.opt.nfl.projections) {
          return (
            row.HouseProjPts || row.ProjPts
          )
        } else {
          return <Lock />
        }
      }
    },
    {
      title: (
        <Tooltip placement="top" title={"Projected points / Salary * 1000"}>
          <span>Proj Value</span>
        </Tooltip>
      ),
      key: 'projval',
      sorter: (a, b) => (Number(b.ProjPts) / Number(b.Salary) * 1000) - (Number(a.ProjPts) / Number(a.Salary) * 1000),
      render: (_, row) => {
        let multiplier = 1000
        if (site === 'ya')
          multiplier = 10
        if (permissions.opt.nfl.projections) {
          return (
            (Number(row.ProjPts) / Number(row.Salary) * multiplier).toFixed(3)
          )
        } else {
          return (Number(row.UserProj || 0) / Number(row.Salary) * multiplier).toFixed(3)
        }
      }
    },
    {
      title: 'Proj Own',
      dataIndex: 'ProjOwn',
      key: 'projOwn',
      sorter: (a, b) => Number(b.ProjOwn) - Number(a.ProjOwn),
      render: (_, row) => {
        if (permissions.opt.nfl.ownership) {
          return row.HouseOwn && row.UserOwn ? (<span style={{color: "#9a9a9a"}}>{row.HouseOwn}</span>) : row.ProjOwn
        } else {
          return <Lock />
        }
      },
    }
  ]

const MinWidth = 1526

const PlayersTable = ({ loading, onAdd, rows = [], permissions, site, showdown}) => {
  const _setWidths = window.innerWidth > MinWidth
  const allCols = [
    ...addCol(onAdd),
    ...playerDetailsCols(_setWidths, showdown),
    ...teamAndGameInfoCols(_setWidths),
    ...playerProjectionCols(permissions, site, showdown)
  ]

  return (
    <StyledTable
      columns={allCols}
      dataSource={rows}
      pagination={{pageSize: 50}}
      bordered
      loading={loading}
      size='small'
      rowKey={_row => `selected-${String(_row.Id)}`}
      scroll={{ y: 300, x: 800 }}
    />
  )
}

export default PlayersTable
